import { render, staticRenderFns } from "./BaseSwiper.vue?vue&type=template&id=43493646&"
import script from "./BaseSwiper.vue?vue&type=script&lang=js&"
export * from "./BaseSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwiper.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports